import { getCategoryTreeData } from "./parser"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

export const initialState = {
    data: {},
    isFetching: false,
    isFetched: false,
    error: null,
}

export const categoryTreeSlice = createSlice({
    name: "categoryTree",
    initialState: initialState,
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchCategories.fulfilled, (state, action) => {
            state.error = null
            state.isFetched = true
            state.isFetching = false
            state.data = getCategoryTreeData(action.payload)
        }),
            builder.addCase(fetchCategories.pending, (state) => {
                state.isFetching = true
                state.isFetched = false
            }),
            builder.addCase(fetchCategories.rejected, (state, action) => {
                state.isFetched = false
                state.isFetching = false
                state.error = action.payload
            })
    },
})

export const fetchCategories = createAsyncThunk("categoryTree/fetchCategories", async (_arg, { extra }) => {
    const { api } = extra
    return await api.get("/api/v4/udp_tree")
})

export const categoryTreeReducer = categoryTreeSlice.reducer
